import authService from '../utils/auth.js';
import { getApiBaseUrl } from '../utils/apiBase.js';

export class KpiIntegrationError extends Error {
  constructor(message, { code, status } = {}) {
    super(message);
    this.name = 'KpiIntegrationError';
    this.code = code;
    this.status = status;
  }
}

/**
 * Server-issued NovaBotX → NovaKPI SSO JWT redirect (HTTPS).
 * @returns {Promise<{ status: string, email: string, redirectUrl: string, method?: string }>}
 */
export async function autoLoginKpi() {
  const response = await fetch(`${getApiBaseUrl()}/api/integrations/kpi/auto-login`, {
    method: 'POST',
    headers: authService.getAuthHeaders()
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new KpiIntegrationError(
      data.message || `Failed to start NovaKPI SSO (${response.status})`,
      { code: data.code, status: response.status }
    );
  }

  return data;
}
